export default __webpack_public_path__ + "static/media/copy.c018356c.svg";